import { PiStudentFill } from "react-icons/pi";

const icon = PiStudentFill;

export const studentsHashtags = {
  default: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  market: { icon, desc: "Buy, sell, and trade with people in your community" },
  icon,
  ride: { icon, desc: "Community focused, flexible & reliable" },
  iee: {
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },

  amharic: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eekteke1: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eekteke2: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  oi: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9scienceon: {
    icon,
    desc: `Grade 9 Science — Ontario. Course Code: SNC1W (De-streamed, 2022 curriculum)`,
  },
  grade9mathematicson: {
    icon,
    desc: `Grade 9 Mathematics — Ontario. Course Code: MTH1W (De-streamed)`,
  },
  grade9englishon: {
    icon,
    desc: `Grade 9 English — Ontario. Course Code: ENG1D / ENG1P`,
  },
  grade9frenchon: {
    icon,
    desc: `Grade 9 French — Ontario. Course Code: FSF1D / FSF1P`,
  },
  grade9geographyon: {
    icon,
    desc: `Grade 9 Geography — Ontario. Course Code: CGC1D / CGC1P`,
  },
  grade9healthyactivelivingon: {
    icon,
    desc: `Grade 9 Healthy Active Living — Ontario. Course Code: PPL1O`,
  },
  grade9learningstrategieson: {
    icon,
    desc: `Grade 9 Learning Strategies — Ontario. Course Code: GLS1O`,
  },
  grade9technologicaleducationon: {
    icon,
    desc: `Grade 9 Technological Education — Ontario. Course Code: TIJ1O`,
  },
  grade9artson: {
    icon,
    desc: `Grade 9 Arts — Ontario. Course Codes: AVI1O / AMU1O`,
  },
  grade9firstnationson: {
    icon,
    desc: `Grade 9 First Nations, Métis and Inuit Studies — Ontario. Course Code: NAC1O`,
  },

  grade10scienceon: {
    icon,
    desc: `Grade 10 Science — Ontario. Course Codes: SNC2D / SNC2P`,
  },
  grade10mathematicson: {
    icon,
    desc: `Grade 10 Mathematics — Ontario. Course Codes: MPM2D / MFM2P`,
  },
  grade10englishon: {
    icon,
    desc: `Grade 10 English — Ontario. Course Codes: ENG2D / ENG2P`,
  },
  grade10canadianhistoryon: {
    icon,
    desc: `Grade 10 Canadian History — Ontario. Course Codes: CHC2D / CHC2P`,
  },
  grade10careerstudieson: {
    icon,
    desc: `Grade 10 Career Studies — Ontario. Course Code: GLC2O`,
  },
  grade10civicson: {
    icon,
    desc: `Grade 10 Civics — Ontario. Course Code: CHV2O`,
  },

  grade11biologyon: {
    icon,
    desc: `Grade 11 Biology — Ontario. Course Codes: SBI3U / SBI3C`,
  },
  grade11functionson: {
    icon,
    desc: `Grade 11 Functions — Ontario. Course Code: MCR3U`,
  },
  grade11chemistryon: {
    icon,
    desc: `Grade 11 Chemistry — Ontario. Course Codes: SCH3U / SCH3C`,
  },
  grade11introductiontoanthropologyon: {
    icon,
    desc: `Grade 11 Anthropology, Psychology & Sociology — Ontario. Course Code: HSP3U/C`,
  },

  grade12advancedfunctionson: {
    icon,
    desc: `Grade 12 Advanced Functions — Ontario. Course Code: MHF4U`,
  },
  grade12biologyon: {
    icon,
    desc: `Grade 12 Biology — Ontario. Course Code: SBI4U`,
  },
  grade12datamanagementon: {
    icon,
    desc: `Grade 12 Data Management — Ontario. Course Code: MDM4U`,
  },
  grade12canadianworldissueson: {
    icon,
    desc: `Grade 12 Canadian & World Issues — Ontario. Course Code: CGW4U`,
  },
  akkhuranacomprehensiveophthalmology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  abmanipalmanualofsurgery: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  aononoperativefracturetreatment: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  aoprinciplesoffracturemanagement: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  atls2010: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  babynelsondrmohamedaelkomy: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  baileylovesshortpracticeofsurgery25th: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  basicandclinicalpharmacologybertramkatzunganthonytrevor: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  bedsidemedicinewithouttears: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  basicsofanesthesiabymanuelpardoronalddmiller: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  bstulitextbookofent: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  bulletpointsinent: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  clarkeentataglance: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  cellbiologyhistologybrs: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  clinicallyorientedanatomymoore: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  currentdiagnosistreatmentobstetricsgynecology7thed: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  currentmedicaldiagnosisandtreatment: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  davidsonsprinciplesandpracticeofmedicine: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  dcduttastextbookofgynecology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  dcduttastextbookofobstetrics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  entsecrets: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  fanosinternalmedicine: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  firstaidforthepsychiatryclerkship5thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  firstaidfortheusmlestep2ck: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  harrisonsprinciplesofinternalmedicine: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  handbookoffracturesbykennethegol: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  histologyatextandatlas: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  hutchinsonsclinicalmethods: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  junqueirasbasichistologytextandatlas13th: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  kaplansadockspockethandbookofclinicalpsychiatry6thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  kaplansadockssynopsisofpsychiatry12thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  kaplanstep1biochemistry: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  kaplanstep1microbiologyimmunology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  langeqapsychiatrybyseanmblitzstein11thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  learningradiologyrecognizingthebasic: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  lippincottsanesthesiareview: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  lippincottsillustratedreviewspharmacology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  lippincottsillustratedqareviewofrubinspathology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  lovellwinterspediatricorthopedics7thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  ludmanabcofent6thed: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  millersanesthesiabyronalddmiller: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  medstarclinicalguideandsynopsis: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  medstarobgyn: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  nelsonofpediatrics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  obstetricandgynecologyobgynteam428: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  obstetricsandgynaecologyoxfordhandbook: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  obstetricsnormalandproblempregnancies: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  obstetricssakshiarora: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  orthobulletsbyislambeltage: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  pakistanshorttextbookofmedicaldiagnosisandmanagement: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  pediatricslangeqa: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  pharmacologyexaminationboardreview: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  psychiatrypretestselfassessmentandreviewbygiuliamancini: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  publichealthandcommunitymedicine: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  radiologyandimagingbydavidsutton: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  reviewofradiology3rded: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  rockwoodandgreensfracturesinadults: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  rockwoodandwilkinsfracturesinchildren: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  schwartzsprinciplesofsurgery: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  selfassessmentreviewent7thedition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  skeletaltraumabasicsciencemanagementandreconstruction: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  tmsrbsclinicalmethodsinsurgery: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  tmsrbsmanualofsurgery: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  textbookofradiologyabdomenandpelvis: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  understandinganesthesia: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  williamsgynecology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  williamherringlearningradiology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  williamsobstetrics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9scienceab: {
    icon,
    desc: 'Course Code: SCI 9 (Alberta Curriculum)\n\nOfficial Textbook: Pearson "Investigating Science 9" (Alberta Edition)',
  },
  grade9mathematicsab: {
    icon,
    desc: 'Course Code: MATH 9 (Alberta Curriculum)\n\nOfficial Textbook: McGraw-Hill "MathLinks 9" (Alberta Edition)',
  },
  grade9englishlanguageartsab: {
    icon,
    desc: 'Course Code: ELA 9 (Alberta Curriculum)\n\nOfficial Textbook: Nelson "Perspectives on Literacy 9" (Alberta Edition)',
  },
  grade9socialstudiesab: {
    icon,
    desc: 'Course Code: SOC 9 (Alberta Curriculum)\n\nOfficial Textbook: Oxford "Issues for Canadians" (Alberta Edition)',
  },
  grade9physicaleducationab: {
    icon,
    desc: 'Course Code: PE 9 (Alberta Curriculum)\n\nOfficial Resource: "Ever Active Schools" (Alberta Guidelines)',
  },
  grade9careerandtechnologyfoundationsab: {
    icon,
    desc: 'Course Code: CTF 9 (Alberta Curriculum)\n\nOfficial Resource: Alberta Education "CTF Modules"',
  },
  grade9healthandlifeskillsab: {
    icon,
    desc: 'Course Code: HLS 9 (Alberta Curriculum)\n\nOfficial Resource: "Teaching Sexual Health" (Alberta Health)',
  },
  grade9fineartsab: {
    icon,
    desc: 'Course Code: ART/DRAMA/MUS 9 (Alberta Curriculum)\n\nOfficial Textbooks:\n\n- Art: "Explorations in Art 9" (Davis)\n\n- Drama: "Spotlight on Drama 9" (Oxford)\n\n- Music: "Music! Its Role 9" (Pearson)',
  },
  grade9indigenousstudiesab: {
    icon,
    desc: 'Course Code: INDG 9 (Alberta Curriculum)\n\nOfficial Resource: "Walking Together" (Alberta Education)',
  },
  grade9frenchasasecondlanguageab: {
    icon,
    desc: 'Course Code: FSL 9 (Alberta Curriculum)\n\nOfficial Textbook: "Découvertes 9" (Nelson)',
  },
  grade10scienceab: {
    icon,
    desc: 'Course Code: SCI 10 (Alberta Curriculum)\nOfficial Textbook: Pearson "Investigating Science 10" (Alberta Edition)',
  },
  grade10mathematicsab: {
    icon,
    desc: 'Course Code: MATH 10C (Alberta Curriculum)\nOfficial Textbook: McGraw-Hill "Pre-Calculus 10" (Alberta Edition)',
  },
  grade10englishlanguageartsab: {
    icon,
    desc: 'Course Code: ELA 10-1 or 10-2 (Alberta Curriculum)\nOfficial Textbook: Nelson "Perspectives on Literacy 10" (Alberta Edition)',
  },
  grade10socialstudiesab: {
    icon,
    desc: 'Course Code: SOC 10-1 or 10-2 (Alberta Curriculum)\nOfficial Textbook: Oxford "Exploring Globalization" (Alberta Edition)',
  },
  grade10physicaleducationab: {
    icon,
    desc: 'Course Code: PE 10 (Alberta Curriculum)\nOfficial Resource: "Ever Active Schools" (Alberta Guidelines)',
  },
  grade10careerandlifemanagementab: {
    icon,
    desc: 'Course Code: CALM 20 (Alberta Curriculum)\nOfficial Resource: "CALM Handbook" (Alberta Education)',
  },
  grade10careerandtechnologystudiesctsab: {
    icon,
    desc: 'Course Code: Various (Alberta Curriculum)\nOfficial Modules: Alberta Education "CTS Pathways"',
  },
  grade10artab: {
    icon,
    desc: 'Course Code: ART 10 (Alberta Curriculum)\nOfficial Textbook: "Explorations in Art 10" (Davis)',
  },
  grade10frenchasasecondlanguageab: {
    icon,
    desc: 'Course Code: FSL 10 (Alberta Curriculum)\nOfficial Textbook: "Découvertes 10" (Nelson)',
  },
  grade10indigenousstudiesab: {
    icon,
    desc: 'Course Code: INDG 10 (Alberta Curriculum)\nOfficial Resource: "Voices of the Land" (Alberta Education)',
  },
  grade11scienceab: {
    icon,
    desc: 'Course Code: SCI 20 (Alberta Curriculum)\nOfficial Textbook: Pearson "Investigating Science 20" (Alberta Edition)',
  },
  grade11chemistryab: {
    icon,
    desc: 'Course Code: CHEM 20 (Alberta Curriculum)\nOfficial Textbook: Nelson "Chemistry 20" (Alberta Edition)',
  },
  grade11physicsab: {
    icon,
    desc: 'Course Code: PHYS 20 (Alberta Curriculum)\nOfficial Textbook: McGraw-Hill "Physics 20" (Alberta Edition)',
  },
  grade11mathematicsab: {
    icon,
    desc: 'Course Code: MATH 20-1 or 20-2 (Alberta Curriculum)\nOfficial Textbook: McGraw-Hill "Pre-Calculus 11" (Alberta Edition)',
  },
  grade11englishlanguageartsab: {
    icon,
    desc: 'Course Code: ELA 20-1 or 20-2 (Alberta Curriculum)\nOfficial Textbook: Nelson "Perspectives on Literacy 20" (Alberta Edition)',
  },
  grade11socialstudiesab: {
    icon,
    desc: 'Course Code: SOC 20-1 or 20-2 (Alberta Curriculum)\nOfficial Textbook: Oxford "Understanding Nationalism" (Alberta Edition)',
  },
  grade11biologyab: {
    icon,
    desc: 'Course Code: BIO 20 (Alberta Curriculum)\nOfficial Textbook: Pearson "Biology 20" (Alberta Edition)',
  },
  grade11careerandlifemanagementab: {
    icon,
    desc: 'Course Code: CALM 20 (Alberta Curriculum)\nOfficial Resource: "CALM Handbook" (Alberta Education)',
  },
  grade11psychologyab: {
    icon,
    desc: 'Course Code: PSYCH 20 (Alberta Curriculum)\nOfficial Textbook: "Psychology: The Science of Mind and Behaviour" (McGraw-Hill)',
  },
  grade11indigenousstudiesab: {
    icon,
    desc: 'Course Code: INDG 20 (Alberta Curriculum)\nOfficial Resource: "Voices of the Land" (Alberta Education)',
  },
  grade11careerandtechnologystudiesctsab: {
    icon,
    desc: 'Course Code: Various (Alberta Curriculum)\nOfficial Modules: Alberta Education "CTS Pathways"',
  },
  grade11artab: {
    icon,
    desc: 'Course Code: ART 20 (Alberta Curriculum)\nOfficial Textbook: "Explorations in Art 20" (Davis)',
  },
  grade11frenchasasecondlanguageab: {
    icon,
    desc: 'Course Code: FSL 20 (Alberta Curriculum)\nOfficial Textbook: "Découvertes 20" (Nelson)',
  },
  grade12scienceab: {
    icon,
    desc: 'Course Code: SCI 30 (Alberta Curriculum)\nOfficial Textbook: Pearson "Investigating Science 30" (Alberta Edition)',
  },
  grade12chemistryab: {
    icon,
    desc: 'Course Code: CHEM 30 (Alberta Curriculum)\nOfficial Textbook: Nelson "Chemistry 30" (Alberta Edition)',
  },
  grade12physicsab: {
    icon,
    desc: 'Course Code: PHYS 30 (Alberta Curriculum)\nOfficial Textbook: McGraw-Hill "Physics 30" (Alberta Edition)',
  },
  grade12mathematicsab: {
    icon,
    desc: 'Course Code: MATH 30-1 or 30-2 (Alberta Curriculum)\nOfficial Textbook: McGraw-Hill "Pre-Calculus 12" (Alberta Edition)',
  },
  grade12englishlanguageartsab: {
    icon,
    desc: 'Course Code: ELA 30-1 or 30-2 (Alberta Curriculum)\nOfficial Textbook: Nelson "Perspectives on Literacy 30" (Alberta Edition)',
  },
  grade12socialstudiesab: {
    icon,
    desc: 'Course Code: SOC 30-1 or 30-2 (Alberta Curriculum)\nOfficial Textbook: Oxford "Understanding Ideologies" (Alberta Edition)',
  },
  grade12biologyab: {
    icon,
    desc: 'Course Code: BIO 30 (Alberta Curriculum)\nOfficial Textbook: Pearson "Biology 30" (Alberta Edition)',
  },
  grade12careerandlifemanagementab: {
    icon,
    desc: 'Course Code: CALM 20 (Alberta Curriculum)\nOfficial Resource: "CALM Handbook" (Alberta Education)',
  },
  grade12psychologyab: {
    icon,
    desc: 'Course Code: PSYCH 30 (Alberta Curriculum)\nOfficial Textbook: "Psychology: Themes and Variations" (Nelson)',
  },
  grade12indigenousstudiesab: {
    icon,
    desc: 'Course Code: INDG 30 (Alberta Curriculum)\nOfficial Resource: "Walking Together" (Alberta Education)',
  },
  grade12careerandtechnologystudiesctsab: {
    icon,
    desc: 'Course Code: Various (Alberta Curriculum)\nOfficial Modules: Alberta Education "CTS Pathways"',
  },
  grade12artab: {
    icon,
    desc: 'Course Code: ART 30 (Alberta Curriculum)\nOfficial Textbook: "Explorations in Art 30" (Davis)',
  },
  grade12frenchasasecondlanguageab: {
    icon,
    desc: 'Course Code: FSL 30 (Alberta Curriculum)\nOfficial Textbook: "Découvertes 30" (Nelson)',
  },
  grade12forensicscienceab: {
    icon,
    desc: 'Course Code: FORENSIC 30 (Alberta Curriculum)\nOfficial Resource: "Forensic Science Fundamentals" (Pearson)',
  },
  grade9sciencebc: {
    icon,
    desc: 'Course Code: SCIENCE 9 (BC Curriculum)\nOfficial Textbook: McGraw-Hill "BC Science 9" (BC Edition)',
  },
  grade9mathematicsbc: {
    icon,
    desc: 'Course Code: MATHEMATICS 9 (BC Curriculum)\nOfficial Textbook: Nelson "MathLinks 9" (BC Edition)',
  },
  grade9englishbc: {
    icon,
    desc: 'Course Code: ENGLISH 9 (BC Curriculum)\nOfficial Textbook: Oxford "SightLines 9" (BC Edition)',
  },
  grade9socialstudiesbc: {
    icon,
    desc: 'Course Code: SOCIAL STUDIES 9 (BC Curriculum)\nOfficial Textbook: Pearson "World History: Societies of the Past"',
  },
  grade9physicalandhealtheducationbc: {
    icon,
    desc: 'Course Code: PHE 9 (BC Curriculum)\nOfficial Resource: "BC PHE Curriculum Guide"',
  },
  grade9applieddesignskillsandtechnologiesbc: {
    icon,
    desc: "Course Code: ADST 9 (BC Curriculum)\nOfficial Modules: BC ADST Curriculum",
  },
  grade9artseducationbc: {
    icon,
    desc: 'Course Code: ARTS 9 (BC Curriculum)\nOfficial Textbook: "Explorations in Art 9" (Davis)',
  },
  grade9frenchbc: {
    icon,
    desc: 'Course Code: FRENCH 9 (BC Curriculum)\nOfficial Textbook: "Découvertes 9" (Nelson)',
  },
  grade9careereducationbc: {
    icon,
    desc: 'Course Code: CAREER EDUCATION 9 (BC Curriculum)\nOfficial Resource: "BC Career Education Guide"',
  },
  grade10sciencebc: {
    icon,
    desc: 'Course Code: SCIENCE 10 (BC Curriculum)\nOfficial Textbook: McGraw-Hill "BC Science 10" (BC Edition)',
  },
  grade10mathematicsbc: {
    icon,
    desc: 'Course Code: MATHEMATICS 10 (BC Curriculum)\nOfficial Textbook: Nelson "Foundations and Pre-Calculus 10" (BC Edition)',
  },
  grade10englishbc: {
    icon,
    desc: 'Course Code: ENGLISH 10 (BC Curriculum)\nOfficial Textbook: Oxford "SightLines 10" (BC Edition)',
  },
  grade10socialstudiesbc: {
    icon,
    desc: 'Course Code: SOCIAL STUDIES 10 (BC Curriculum)\nOfficial Textbook: Pearson "Horizons: Canada in the 20th Century"',
  },
  grade11sciencebc: {
    icon,
    desc: 'Course Code: SCIENCE 11 (BC Curriculum)\nOfficial Textbook: McGraw-Hill "BC Science 11" (BC Edition)',
  },
  grade11mathematicsbc: {
    icon,
    desc: 'Course Code: FOUNDATIONS 11 or PRE-CALC 11 (BC Curriculum)\nOfficial Textbook: Nelson "Pre-Calculus 11" (BC Edition)',
  },
  grade11englishbc: {
    icon,
    desc: 'Course Code: ENGLISH 11 (BC Curriculum)\nOfficial Textbook: Oxford "SightLines 11" (BC Edition)',
  },
  grade12sciencebc: {
    icon,
    desc: 'Course Code: SCIENCE 12 (BC Curriculum)\nOfficial Textbook: McGraw-Hill "BC Science 12" (BC Edition)',
  },
  grade12mathematicsbc: {
    icon,
    desc: 'Course Code: PRE-CALC 12 or CALCULUS 12 (BC Curriculum)\nOfficial Textbook: Nelson "Pre-Calculus 12" (BC Edition)',
  },
  grade12englishbc: {
    icon,
    desc: 'Course Code: ENGLISH 12 (BC Curriculum)\nOfficial Textbook: Oxford "SightLines 12" (BC Edition)',
  },
  grade9englishlanguagearts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9mathematics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9science: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9socialstudies: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9visualart: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9drama: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9musicconcertband: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9musicguitar: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9introductiontocomputerprogrammingandvirtualreality: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9textileartsanddesign: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9electricityelectronics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9foodsandnutrition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9woodworktechnology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9powermechanics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10englishlanguagearts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10mathematics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10science: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10socialstudies: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10drama: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10music: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10computerscience: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10foodsandnutrition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10woodworkingtechnology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10electronics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10textileartsanddesign: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11englishlanguagearts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11mathematics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11science: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11socialstudies: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11visualarts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11drama: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11music: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11computerscience: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11foodsandnutrition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11constructiontechnology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12englishlanguagearts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12mathematics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12science: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12socialstudies: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12visualarts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12computerscience: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12drama: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12music: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12foodsandnutrition: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12constructiontechnology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12modernlanguages: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12entrepreneurshipandmarketing: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12environmentalscience: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12chemistry: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12biology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12physics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade12appliedmathematics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  secondary3scienceettechnologieqc: {
    icon,
    desc: 'Course Code: Science et Technologie (ST) - Cycle 1\nOfficial Textbook: "Observatoire" (ERPI)',
  },
  secondary3mathmatiqueqc: {
    icon,
    desc: 'Course Code: Mathématique - Culture, société et technique (CST)\nOfficial Textbook: "Point de mire" (Chenelière)',
  },
  secondary4scienceettechnologieqc: {
    icon,
    desc: 'Course Code: Science et Technologie (ST) - Cycle 2\nOfficial Textbook: "Synergie" (ERPI)',
  },
  secondary4histoireduqubecetcanadaqc: {
    icon,
    desc: 'Course Code: Histoire - Programme obligatoire\nOfficial Textbook: "Constats" (Chenelière)',
  },
  secondary5chimieqc: {
    icon,
    desc: 'Course Code: Chimie - Séquence Sciences naturelles (SN)\nOfficial Textbook: "Horizon" (ERPI)',
  },
  secondary5mathmatiqueqc: {
    icon,
    desc: 'Course Code: \n  - SN (Sciences naturelles)\n  - TS (Technico-sciences)\n  - CST (Culture, société et technique)\nOfficial Textbook: "Cahiers de mathématique" (Grafiden)',
  },
  grade9visualarts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9music: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9physicaleducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9frenchlanguage: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade9technologyeducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10visualarts: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10physicaleducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10frenchlanguage: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade10technologyeducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11physicaleducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11frenchlanguage: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  grade11technologyeducation: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  criticalthinkingmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  economicsmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  emergingtechnologiesmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  entrepreneurshipmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  generalbiologymodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  generalchemistrymodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  generalphysicsmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  generalpysychologymodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  geographymodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  globaltrendsmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  inclusivenessmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  moralandcivicmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  physicalfitnessmodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  communicativeenglishlanguageskillsiflen1011: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  communicativeenglishlanguageskillsii: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  generalphysics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  historyofethiopianandthehornoctober2022finalomoticrevisedandfinal: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  mathematicsnaturalsciencemodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  mathematicssocialsciencemodule: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  socialantropology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eueebiology: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eueechemistry: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eueegoegraphy: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eueemath: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  eueephysics: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  igo: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
  yeoge: {
    icon,
    desc: "Canadian students sharing study tips, school life, and academic wins 🇨🇦",
  },
};
